import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import InviteAccept from "@/pages/InviteAccept";
import ResidentWizard from "@/pages/ResidentWizard";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import CreateSVJ from "@/pages/admin/CreateSVJ";
import SVJWorkspace from "@/pages/admin/SVJWorkspace";
import Teams from "@/pages/admin/Teams";
import TechSchedule from "@/pages/TechSchedule";
import ProposalApproval from "@/pages/ProposalApproval";

function Protected({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center text-slate-500">Načítání…</div>;
  if (!user) return <Navigate to="/prihlaseni" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={user.role === "technician" ? "/technik" : "/admin"} replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="/prihlaseni" element={<Login />} />
          <Route path="/pozvanka/:token" element={<InviteAccept />} />
          <Route path="/r/:token" element={<ResidentWizard />} />
          <Route path="/schvaleni/:token" element={<ProposalApproval />} />
          <Route path="/technik" element={<Protected roles={["technician", "superadmin"]}><TechSchedule /></Protected>} />
          <Route path="/admin" element={<Protected roles={["superadmin", "svj_admin"]}><AdminLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="svj/new" element={<CreateSVJ />} />
            <Route path="svj/:id" element={<SVJWorkspace />} />
            <Route path="teams" element={<Teams />} />
          </Route>
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
